// apps/admin-panel/src/app/core/guards/restaurant.guard.ts
import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const restaurantGuard: CanActivateFn = async () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const profile = await authService.getUserProfile(); //

    // Si el usuario es 'comercial', tiene permiso global
    if (profile?.role === 'comercial') {
        return true;
    }

    // Si no tiene restaurantes a su cargo, debe registrar uno primero
    if (!profile?.memberships || profile.memberships.length === 0) {
        return router.createUrlTree(['/setup']);
    }

    return true;
};